import { connect } from "react-redux";
import { gradeColors } from "../../../Constants/options";
import { Link } from "react-router-dom";
import { getDrivers, setStateToDefault, updateDriverStatus } from "../../../Redux/Actions/DriverActions";
import DateService from "../../../Services/DateService";
import ProfileDetailsIcon from "../../../Assets/profileDetailsIcon.svg";
import MoveDriverIcon from "../../../Assets/moveDriverIcon.svg";

function AcceptedDriverTableCellBody({ column, value, details, remove, updateDriverStatus, setStateToDefault, getDrivers }) {

    if (column.id === "number") {
        return (
            <div>#{value}</div>
        );
    } else if (column.id === "grade") {
        return (
            <div className="grade-circle-cell"><span style={{ backgroundColor: gradeColors[value] }} className="grade-circle"></span></div>
        );
    } else if (column.id === "colorCode") {
        if (value !== null && value !== "-") {
            const colorvalue = value;
            return (
                <div className="color-line" style={{ backgroundColor: "#" + colorvalue }}></div>
            );
        } else {
            const colorvalue = "707070";
            return (
                <div className="color-line" style={{ backgroundColor: "#" + colorvalue }}></div>
            );
        }
    } else if (column.id === "location") {
        if (value !== null && value !== "-") {
            return (
                <div className="text">{column.format && typeof value === "number" ? column.format(value) : value}</div>
            );
        } else {
            const defaultlocationtext = "-";
            return (
                <div className="text">{defaultlocationtext}</div>
            );
        }
    } else if (column.id === "category") {
        if (value !== null && value !== "-") {
            return (
                <div className="text">{column.format && typeof value === "number" ? column.format(value) : value}</div>
            );
        } else {
            const defaultcategory = 1;
            return (
                <div className="text">{defaultcategory}</div>
            );
        }
    } else if (column.id === "id") {
        return (
            <div className="driver-operations">
                <Link to={`/driver/${value}`} onClick={() => setStateToDefault()} className="button">
                    <img alt='ProfileDetailsIcon' src={ProfileDetailsIcon} />
                </Link>
                <img className='button' alt='MoveDriverIcon' src={MoveDriverIcon} onClick={() => updateDriverStatus(value, { status: "Deleted" }, setTimeout(() => { getDrivers(); }, 0), DateService.getCurrentDate())} />
            </div>
        );
    } else {
        return (
            <div className="text">{column.format && typeof value === "number" ? column.format(value) : value}</div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        drivers: { status },
    } = state;
    return { status };
};

export default connect(mapStateToProps, { updateDriverStatus, setStateToDefault, getDrivers })(AcceptedDriverTableCellBody);
